import script from "./MilestoneTimeline.vue?vue&type=script&setup=true&lang=js"
export * from "./MilestoneTimeline.vue?vue&type=script&setup=true&lang=js"

import "./MilestoneTimeline.vue?vue&type=style&index=0&id=ef45412e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef45412e"]])

export default __exports__